define(
  'C3.Available.View',
  ['SCView', 'tekyard_available_view.tpl'],
  function(SCViewComponent, tekyard_available_view_tpl) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function AvailableView(options) {
      SCView.call(this);

      this.options = options || {};
      this.items = options.items;
      this.template = tekyard_available_view_tpl;

    }

    // Inherit parent instance methods.
    AvailableView.prototype = Object.create(SCView.prototype);

    // Restore the constuctor.
    AvailableView.prototype.constructor = AvailableView;

    AvailableView.prototype.getContext = function() {
      //console.log(this.items)
      return {
        totalItems : this.items ? this.items.length : 0
      }
    }

    // Return the AMD constructor.
    return AvailableView;
  }
);
